import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { closed } from "../../components/drawer/drawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearOccupationTypeDetails } from "./occupationtypeSlice";
import {
  createOccupationType,
  getAllOccupationType,
  getOccupationTypeById,
  updateOccupationType,
} from "./services/occupation.services";

const CreateOccupationType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const OccupationTypeDetail = useAppSelector(
    (state) => state.occupationtype.OccupationTypeDetail
  );
  const OccupationGUID = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector(
    (state) => state.occupationtype.formLoading
  );

  useEffect(() => {
    return () => {
      dispatch(clearOccupationTypeDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (OccupationGUID) {
      dispatch(getOccupationTypeById(OccupationGUID));
    }
  }, [OccupationGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!OccupationGUID) {
        const insertPayload = {
          OccupationName: values.OccupationName,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createOccupationType(insertPayload));
        if (response?.payload?.Status === 201) {
          dispatch(closed());
          dispatch(clearOccupationTypeDetails());
          dispatch(getAllOccupationType());
        }
      } else {
        const editPayload = {
          ID: values.ID,
          OccupationGUID: OccupationGUID,
          OccupationName: values.OccupationName,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateOccupationType(editPayload));
        if (response?.payload?.Status === 200) {
          dispatch(closed());
          dispatch(clearOccupationTypeDetails());
          dispatch(getAllOccupationType());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={OccupationTypeDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem className="drawer-header">
              <Typography.h4 className="m-0">
                {OccupationGUID ? "Update Occupation" : "Create Occupation"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="OccupationName"
                label="Occupation"
                placeholder="Occupation"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                label={"Status"}
                placeholder="Status"
                validator={requiredValidator} astrike={true}
                component={FormSelectionField}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                marginTop: 20,
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={OccupationGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateOccupationType;
